<script>
import FeedbackForm from '@/feedback/components/FeedbackForm.vue';

export default {
  components: {
    FeedbackForm,
  },

  methods: {
    onCancel() { this.$router.go(-1); },
  },
}
</script>

<template>
  <div>
    <feedback-form
      @cancel="onCancel" />
  </div>
</template>



// WEBPACK FOOTER //
// src/feedback/views/FeedbackView.vue